import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import './UpdateModal.css';

interface UpdateModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    message: string;
    date?: string;
}

export const UpdateModal: React.FC<UpdateModalProps> = ({
    isOpen,
    onClose,
    title,
    message,
    date
}) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        return () => setMounted(false);
    }, []);

    if (!isOpen || !mounted) return null;

    return createPortal(
        <div className="update-modal-overlay" onClick={onClose}>
            <div className="update-modal" onClick={e => e.stopPropagation()}>
                <div className="update-header">
                    <h2>{title}</h2>
                    {date && <span className="update-date">{date}</span>}
                </div>
                <div className="update-body">
                    <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                        {message}
                    </ReactMarkdown>
                </div>
                <button className="update-close-btn" onClick={onClose}>
                    Got it!
                </button>
            </div>
        </div>,
        document.body
    );
};
